import React from "react";

function TicketProcedures() {
    return (
        <>
            <div>TicketProcedures</div>
        </>
    );
}

export default TicketProcedures;
